import React from 'react';
import PropTypes from 'prop-types';
import PhotoIcon from '@domain-group/fe-co-icon/lib/js/photo';
import VideoIcon from '@domain-group/fe-co-icon/lib/js/video';
import ThreeDimensionalIcon from '@domain-group/fe-co-icon/lib/js/three-dimensional';
import { mediaStats, mediaItem, value, icon } from './media-stats.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MediaStats = _ref => {
  var numPhotos = _ref.numPhotos,
    hasVideo = _ref.hasVideo,
    has3dTour = _ref.has3dTour;
  return ___EmotionJSX("div", {
    css: mediaStats
  }, numPhotos > 0 && ___EmotionJSX("div", {
    css: mediaItem
  }, ___EmotionJSX(PhotoIcon, {
    css: icon,
    size: "custom"
  }), ___EmotionJSX("span", {
    css: value
  }, numPhotos)), hasVideo && ___EmotionJSX("div", {
    css: mediaItem
  }, ___EmotionJSX(VideoIcon, {
    css: icon,
    size: "custom"
  })), has3dTour && ___EmotionJSX("div", {
    css: mediaItem
  }, ___EmotionJSX(ThreeDimensionalIcon, {
    css: icon,
    size: "custom"
  }), ___EmotionJSX("span", {
    css: value
  }, "3D")));
};
MediaStats.propTypes = {
  numPhotos: PropTypes.number,
  hasVideo: PropTypes.bool,
  has3dTour: PropTypes.bool
};
MediaStats.defaultProps = {
  numPhotos: 0,
  hasVideo: false,
  has3dTour: false
};
export default MediaStats;